import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import type {
  AddFeatureFlagRolloutGroupsRequest,
  FeatureFlagRecord,
} from "../FeatureFlagRecord";

import { featureFlagQueryKeys } from "./featureFlagQueryKeys";
import * as UseFeatureFlags from "./useFeatureFlags";

interface AddFeatureFlagRolloutGroupsArgs {
  featureFlagId: string;
  request: AddFeatureFlagRolloutGroupsRequest;
}

export function useAddFeatureFlagRolloutGroups() {
  const { featureFlagService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<FeatureFlagRecord, Error, AddFeatureFlagRolloutGroupsArgs>(
    {
      mutationFn: ({ featureFlagId, request }) =>
        featureFlagService.addRolloutGroups(featureFlagId, request),
      onSuccess: () => {
        void queryClient.invalidateQueries({
          queryKey: UseFeatureFlags.getQueryKey(),
        });
        void queryClient.invalidateQueries({
          queryKey: featureFlagQueryKeys.states(),
        });
      },
    },
  );
}
